'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { FormulaEditor } from './FormulaEditor';
import './FormulaExpandModal.css';

interface Props {
  value: string;
  onChange: (source: string) => void;
  fieldNames: string[];
  scope?: 'record' | 'batch';
  onClose: () => void;
}

// Live-edit model (intentional, not a missing-Cancel bug): edits flow straight
// to the shared Expression source via `onChange` with no draft buffer — so
// Escape / overlay-click / Done all close and PERSIST the edit; discarding is
// not supported by design.
export function FormulaExpandModal({ value, onChange, fieldNames, scope, onClose }: Props) {
  return (
    <Dialog.Root open onOpenChange={(o) => { if (!o) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="formula-expand__overlay" />
        <Dialog.Content className="formula-expand__content" aria-describedby={undefined}>
          <Dialog.Title className="formula-expand__title">Edit formula</Dialog.Title>
          <div className="formula-expand__editor">
            <FormulaEditor
              value={value}
              onChange={onChange}
              fieldNames={fieldNames}
              scope={scope}
            />
          </div>
          <div className="formula-expand__actions">
            <button type="button" onClick={onClose}>Done</button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
